import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

const meta = { permissions: ['administrator'] };

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/sites'),
      component: SettingsWrapper,
      children: [{ path: '', name: 'settings_sites', component: Index, meta }],
    },
  ],
};
